// extracted by mini-css-extract-plugin
export default {"AppWrapper":"App_AppWrapper__cbyq5"};